import React from "react";
import "../styles/checkbox.scss";

/**
 * Checkbox — MangoTV Design System
 * Figma: Checkbox component (24654:4465)
 * 32x32 checkbox with label text
 * Unchecked: #262626 bg, #404040 border
 * Checked: #fafafa bg with check icon
 * Label: Poppins 16px/24px bold #fafafa
 */
const Checkbox = ({ label, checked = false, onChange, disabled = false }) => {
  return (
    <label className={`mango-checkbox ${disabled ? "mango-checkbox--disabled" : ""}`}>
      <div
        className={`mango-checkbox__box ${checked ? "mango-checkbox__box--checked" : ""}`}
        onClick={() => !disabled && onChange(!checked)}
      >
        {checked && (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.3332 4L5.99984 11.3333L2.6665 8"
              stroke="#0a0a0a"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      {label && (
        <span className="mango-checkbox__label">{label}</span>
      )}
    </label>
  );
};

export default Checkbox;
